import RoleMenuManagementContainer from "../../../Component/Application/rolemenus/role-menu-container"

const RoleMenuPage = () => {
    return (
        <div className="page-body">
            <RoleMenuManagementContainer />
        </div>
    );
};

export default RoleMenuPage;